export default function (store) {
    let $wrapper = null;
    let is_open = false;

    let unsubscribe_auth = null;
    let unsubscribe_user = null;

    const renderLinks = () => {
        const auth = store.get('auth');
        const user = store.get('user');
        const is_logged_in = auth && auth.logged_in;

        let user_name = user.first_name || '';

        if (user.nickname) user_name = user.nickname;

        if (is_logged_in) {
            return `
                <button id="UserMenuButton">${user_name}<i class="fas fa-circle-user"></i></button>
                <div id="UserMenu" class="menu">
                    <ul>
                        <li><a href="/account/details"><i class="fas fa-circle-user"></i>My Account</a></li>
                        <li><a href="/account/subscription"><i class="fas fa-star"></i>Subscription</a></li>
                        <li><a href="/logout"><i class="fas fa-sign-out-alt"></i>Log Out</a></li>
                    </ul>
                </div>
            `
        } else {
            return `
                <a href="/register">Register</a>
                <a href="/login">Log In</a>
            `
        }
    }

    const openMenu = () => {
        is_open = true;
        const $menu = document.getElementById("UserMenu");
        const $menu_button = document.getElementById("UserMenuButton");
        $menu?.classList.add("is-open");
        $menu_button?.setAttribute("aria-expanded", "true");
    }

    const closeMenu = () => {
        is_open = false;
        const $menu = document.getElementById("UserMenu");
        const $menu_button = document.getElementById("UserMenuButton");
        $menu?.classList.remove("is-open");
        $menu_button?.setAttribute("aria-expanded", "false");
    }

    const toggleMenu = () => {
        is_open ? closeMenu() : openMenu();
    }

    return {
        render() {
            return renderLinks()
        },

        async onMount() {
            $wrapper = document.getElementById("HeaderUser");

            $wrapper.innerHTML = this.render();

            this._onWrapperClick = (event) => {
                const $target = event.target.closest("#UserMenuButton");
                if ($target) {
                    event.preventDefault();
                    toggleMenu();
                }
            };
            $wrapper.addEventListener("click", this._onWrapperClick);

            this._onKeyDown = (e) => {
                if (e.key === "Escape" && is_open) closeMenu();
            };
            document.addEventListener("keydown", this._onKeyDown);

            this._onDocumentClick = (event) => {
                if (is_open && $wrapper && !$wrapper.contains(event.target)) {
                    closeMenu();
                }
            };
            document.addEventListener("click", this._onDocumentClick);

            // Subscribe to store changes
            unsubscribe_auth = store.subscribe("auth", () => {
                $wrapper.innerHTML = this.render();
            });

            unsubscribe_user = store.subscribe("user", () => {
                $wrapper.innerHTML = this.render();
            });
        },

        async onUnmount() {
            $wrapper?.removeEventListener("click", this._onWrapperClick);
            document.removeEventListener("keydown", this._onKeyDown);
            document.removeEventListener("click", this._onDocumentClick);

            if (unsubscribe_auth) unsubscribe_auth();
            if (unsubscribe_user) unsubscribe_user();
        },

        close: closeMenu,
    };
};
